import { CoverImage, Image, Weight } from 'components'
import { Fonts, Text, TextSize } from 'components/typography'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'
//container for social media buttons
export const FooterSocialButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 18px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    justify-content: flex-start;
    margin-bottom: 20px;
  `}
`

// style wrapper for the footer logo
export const FooterLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  width: fit-content;
  ${({ theme }) => theme.mediaWidth.Mobile`
    width: 100%;
    text-align: left;
    margin-bottom: 0
  `}
  & svg {
    & path {
      fill: ${GLOBAL_COLORS.white};
    }
  }
`

export const WhiteText = styled(Text)`
  color: ${GLOBAL_COLORS.white};
`
//styling for footer social media buttons
export const FooterSocialButtonsContainer = styled(WhiteText)`
  transition: 0.4s all;
  &:hover {
    cursor: pointer;
  }
  font-size: ${TextSize.small};
`

export const FooterWrapper = styled.footer`
  width: 100vw;
  background-color: ${GLOBAL_COLORS.customBlack};
  ${({ theme, height, opened }) => theme.mediaWidth.Mobile`
    margin-bottom: ${opened ? height + 20 : height}px;
    padding: 0 20px;
    width: auto;
  `}
`

export const FooterContent = styled.div`
  max-width: 825px;
  margin: 0 auto;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.Tablet`
    max-width: 680px;
  `}
`

export const Legal = styled.div`
  text-align: justify;
  font-size: ${TextSize.tiny};
  font-family: ${Fonts.DMSans};
  color: ${GLOBAL_COLORS.white};
  height: fit-content;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 30px;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.Tablet`
    margin-top: 10px; 
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-top: 15px;
  `}
`
export const LegalBorder = styled.div`
  width: 100%;
  height: 1px;
  border-top: 1px solid ${GLOBAL_COLORS.seashellWhite};
  margin-bottom: 15px;
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  height: fit-content;
  width: 100%;
  align-items: center;
  margin-top: 15px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    justify-content: center;  
    flex-wrap: wrap; 
  `}
  ${({ theme }) => theme.mediaWidth.Tablet`
  flex-wrap: wrap;
  padding-top: 10px;
`}
`

export const TopFooterWrapper = styled.div`
  display: flex;
  gap: 80px;
  padding: 60px 0 30px;
  > div:nth-child(2) {
    min-width: 225px;
  }
  > div:first-child {
    width: fill-available;
  }
  ${({ theme }) => theme.mediaWidth.Mobile`
    flex-direction: column;    
    padding: 30px 0 30px;
  `}
`

export const FooterColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const StyledTitle = styled(WhiteText)`
  font-weight: ${Weight.Bold};
  line-height: 28px;
`

export const SubscribeWrapper = styled.div``
export const SocialsWrapper = styled.div``

export const EmailWrapper = styled.div`
  margin: 20px 0 17px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin: 10px 0 8px;  
  `}
`
export const CompanyWrapper = styled.div``
export const RowFlexWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-top: 10px;
  `}
`
export const CompanyItem = styled(WhiteText)`
  cursor: pointer;
  transition: 0.4s all;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.6;
  }
`

export const IconWrapper = styled(Image)`
  height: 24px;
  width: 24px;
  margin-right: 10px;
  border-radius: 50%;
`

export const SocialIconWrapper = styled.div`
  height: 26px;
  width: 26px;
  border-radius: 50%;
  box-sizing: border-box;
  cursor: pointer;
  transition: 0.4s all;
  & > svg > path {
    fill: ${GLOBAL_COLORS.white};
  }
  & > svg > g > path {
    fill: ${GLOBAL_COLORS.white};
  }
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.6;
  }
`

export const ProductsColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ProductsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 20px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    gap: 20px;
    margin-top: 10px;
  `}
`

export const ProductItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 0.4s all;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.6;
  }
`

export const ProductText = styled(WhiteText)`
  font-weight: ${Weight.Medium};
`

export const EmailText = styled(WhiteText)`
  max-width: 550px;
`

export const StyledLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
  transition: 0.4s all;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.6;
  }
`

export const Logo = styled(CoverImage)`
  width: 32px;
  height: 32px;
  margin-right: 10px;
`
